import router from "../router/index.js";

const user = JSON.parse(localStorage.getItem("user"));

const userMail = localStorage.getItem("userMail");

//If the user is locally stored, then suppress the token in the application and store it in vuex as well. Otherwise, set it to null
const state = user
  ? (() => {
      delete user.refreshedTokens;
      return {
        user: user,
        isLoggedIn: true
      };
    })()
  : {
      user: null,
      isLoggedIn: false
    };

state.mail = userMail ? userMail : "";

const UserModule = {
  state,
  actions: {
    PostSuccessLogin({ commit }, { tokenUser, rememberUser }) {
      localStorage.setItem("user", JSON.stringify(tokenUser));

      if (rememberUser.KeepMail) {
        localStorage.setItem("userMail", rememberUser.mail);
      } else {
        localStorage.removeItem("userMail");
      }

      commit("SuccessLogin", tokenUser);
      router.push("/");
    },
    PostSuccessLogout({ commit }) {
      localStorage.removeItem("user");
      commit("SuccessLogout");
      router.push("/login");
    }
  },
  mutations: {
    SuccessLogin(state, tokenUser) {
      delete tokenUser.refreshedTokens;
      state.user = tokenUser;
      state.isLoggedIn = true;
    },
    SuccessLogout(state) {
      state.user = null;
      state.isLoggedIn = false;
    }
  },
  getters: {
    User: state => {
      return state.user;
    },
    UserId: state => {
      return state.user.id;
    },
    UserMail: state => {
      return state.mail;
    },
    UserName: state => {
      return state.user.name;
    },
    IsLoggedIn: state => {
      return state.isLoggedIn;
    },
    isAdmin: state => {
      return state.user.roles.includes("Admin");
    }
  }
};

export default UserModule;
